import { render } from "./FeedbackBoard.vue?vue&type=template&id=e494dc04&scoped=true"
import script from "./FeedbackBoard.vue?vue&type=script&lang=js"
export * from "./FeedbackBoard.vue?vue&type=script&lang=js"

import "./FeedbackBoard.vue?vue&type=style&index=0&id=e494dc04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e494dc04"]])

export default __exports__